import * as userActions from '../user/actions';
import * as FOIVSmallSubCategoriesActions from './actions';
import { CLEAN_PERSISTED_STORAGE } from '~redux_related/GENERAL/actions';

const initialState = {
    list: null,
    isFetching: false,
    isLoaded: false,
    error: '',
};

export const FOIVSmallSubCategoriesReducer = (state = initialState, action) => {
    switch (action.type) {
        case FOIVSmallSubCategoriesActions.SET_FOIV_SMALL_SUB_CATEGORIES_FETCHING:
            return {
                ...state,
                isFetching: action.isFetching,
            };

        case FOIVSmallSubCategoriesActions.SET_FOIV_SMALL_SUB_CATEGORIES_ERROR:
            return {
                list: null,
                isFetching: false,
                isLoaded: true,
                error: action.error,
            };

        case FOIVSmallSubCategoriesActions.SET_FOIV_SMALL_SUB_CATEGORIES:
            return {
                list: action.list,
                isFetching: false,
                isLoaded: true,
                error: '',
            };

        case FOIVSmallSubCategoriesActions.ABORT_FOIV_SMALL_SUB_CATEGORIES_REQUEST:
            return initialState;

        case FOIVSmallSubCategoriesActions.CLEAN_FOIV_SMALL_SUB_CATEGORIES:
            return initialState;

        case userActions.LOGOUT:
            return initialState;

        case userActions.LOGIN:
            // console.log('+++LOGIN USER 12+++');
            return initialState;

        case CLEAN_PERSISTED_STORAGE:
            console.log('+++CLEAN PERSISTED STORAGE 15+++');
            return initialState;

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/redux_related/FOIVSmallSubCategories/reducer.js